import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, isDirty, isValid, reset, change, getFormSyncErrors } from 'redux-form';
import { actions as documentOutputActions, selectors as documentOutputSelectors } from 'ducks/documentOutput';
import LocalShipmentOutputDialog from './LocalShipmentOutputDialog';
import { IApplicationState } from 'ducks/reducers';
import { selectors as staffSelectors } from 'ducks/staff';

const FORM_NAME = 'LocalShipmentOutputForm';
const mapStateToProps = (state: IApplicationState) => ({
  unpackingReportDocumentOutputOptions: documentOutputSelectors.options('PR', 'LocalShipmentDespatchOutput')(state),
  dirty: isDirty(FORM_NAME)(state),
  values: getFormValues(FORM_NAME)(state),
  isValid: isValid(FORM_NAME)(state),
  currentUserId: staffSelectors.id(state) ? staffSelectors.id(state) : '',
  formSyncErrors: getFormSyncErrors(FORM_NAME)(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    resetForm: () => reset(FORM_NAME),
    setUnpackingReportDocumentOutputOptions: (options) => documentOutputActions.updateInitialOptions('SO', 'LocalShipmentDespatchOutput', options),
    clearUnpackingReportDocumentOutputOptions: () => documentOutputActions.clearInitialOptions('SO', 'LocalShipmentDespatchOutput'),
    changeFormFieldValue: (fieldName: string, fieldValue: any) => change(FORM_NAME, fieldName, fieldValue),
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LocalShipmentOutputDialog);
